import {
  GET_LOST_ORDERS,
  GET_LOST_ORDERS_SUCCESS,
  GET_LOST_ORDERS_FAIL,
  ADD_LOST_ORDER,
  ADD_LOST_ORDER_SUCCESS,
  ADD_LOST_ORDER_FAIL,
  UPDATE_LOST_ORDER,
  UPDATE_LOST_ORDER_SUCCESS,
  UPDATE_LOST_ORDER_FAIL,
  DELETE_LOST_ORDER,
  DELETE_LOST_ORDER_SUCCESS,
  DELETE_LOST_ORDER_FAIL,
  SHOW_LOADING,
  HIDE_LOADING,
} from "./actionTypes"

// GET ALL LOST ORDERS
export const getLostOrders = () => ({
  type: GET_LOST_ORDERS,
})
export const getLostOrdersSuccess = lost_orders => ({
  type: GET_LOST_ORDERS_SUCCESS,
  payload: lost_orders,
})
export const getLostOrdersFail = error => ({
  type: GET_LOST_ORDERS_FAIL,
  payload: error,
})
// ADD NEW LOST ORDER
export const addLostOrder = lost_order => ({
  type: ADD_LOST_ORDER,
  payload: lost_order,
})
export const addLostOrderSuccess = lost_order => ({
  type: ADD_LOST_ORDER_SUCCESS,
  payload: lost_order,
})
export const addLostOrderFail = error => ({
  type: ADD_LOST_ORDER_FAIL,
  payload: error,
})
// UPDATE LOST ORDER
export const updateLostOrder = lost_order => ({
  type: UPDATE_LOST_ORDER,
  payload: lost_order,
})
export const updateLostOrderSuccess = lost_order => ({
  type: UPDATE_LOST_ORDER_SUCCESS,
  payload: lost_order,
})
export const updateLostOrderFail = error => ({
  type: UPDATE_LOST_ORDER_FAIL,
  payload: error,
})
// DELETE LOST ORDER
export const deleteLostOrder = lost_order => ({
  type: DELETE_LOST_ORDER,
  payload: lost_order,
})
export const deleteLostOrderSuccess = lost_order => ({
  type: DELETE_LOST_ORDER_SUCCESS,
  payload: lost_order,
})
export const deleteLostOrderFail = error => ({
  type: DELETE_LOST_ORDER_FAIL,
  payload: error,
})
// DISPLAY LOADING ICON
export const showLoading = status => ({
  type: SHOW_LOADING,
  payload: status,
})
export const hideLoading = status => ({
  type: HIDE_LOADING,
  payload: status,
})